import { render, staticRenderFns } from "./OwnWarehouse.vue?vue&type=template&id=0140a172&"
import script from "./OwnWarehouse.vue?vue&type=script&lang=js&"
export * from "./OwnWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./OwnWarehouse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports